// src/UI/SearchBar/SearchBar.tsx
import React from "react";
import { IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";

// Импортируем наши стилизованные компоненты
import { SearchBarContainer, StyledTextField } from "./style.ts";

interface SearchBarProps {
  searchValue: string;
  onSearchChange: (newVal: string) => void;

  /** Нужно ли показывать иконку фильтра */
  withFilter?: boolean;

  /** Колбэк при клике на иконку фильтра */
  onFilterClick?: () => void;

  /** Плейсхолдер для поля ввода */
  placeholder?: string;
}

/**
 * Универсальный компонент поиска
 */
const SearchBar: React.FC<SearchBarProps> = ({
  searchValue,
  onSearchChange,
  withFilter = false,
  onFilterClick,
  placeholder = "Поиск..."
}) => {
  return (
    <SearchBarContainer>
      <StyledTextField
        placeholder={placeholder}
        variant="outlined"
        size="small"
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        InputProps={{
            endAdornment: <SearchIcon style={{ marginRight: 8 }} />
        }}
      />

      {withFilter && (
        <IconButton onClick={onFilterClick}>
          <FilterListIcon />
        </IconButton>
      )}
    </SearchBarContainer>
  );
};

export default SearchBar;
